import React from "react";
import { AHIcon, AHText, Box } from "arkh";
import { DateTime } from "luxon";

export function WidgetTeamScheduleTimeRangeIndicator({
  startAt,
  deadlineAt,
  freq,
}: {
  freq: "WEEKLY" | "MONTHLY";
  startAt: string;
  deadlineAt: string | null | undefined;
}) {
  const style =
    freq === "WEEKLY"
      ? ({
          weekday: "short",
        } as const)
      : ({
          month: "short",
          day: "numeric",
        } as const);

  return (
    <Box
      style={{ flexDirection: "row", alignItems: "center" }}
      spaceBottom="xsmall"
    >
      <AHText type="info-small" color="text-secondary">
        {capFirstLetter(
          DateTime.fromISO(startAt).toLocaleString(style).toString()
        )}
      </AHText>
      {deadlineAt ? (
        <AHIcon
          type="arrow-right"
          color="text-secondary"
          spaceHorizontal="xsmall"
          size="xxsmall"
        />
      ) : null}
      {deadlineAt ? (
        <AHText type="info-small" color="text-secondary">
          {capFirstLetter(DateTime.fromISO(deadlineAt).toLocaleString(style))}
        </AHText>
      ) : null}
    </Box>
  );
}

function capFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
